import type { MfaStepUpErrorDetail } from "./mfaStepUpError";

export type MfaStepUpSignal = { detail?: MfaStepUpErrorDetail; userId?: string };
type MfaStepUpListener = (signal?: MfaStepUpSignal) => void;

const listeners = new Set<MfaStepUpListener>();

/**
 * A step-up refusal is detected by a network interceptor registered at boot, and has to be acted
 * on by a mounted React component. They have no other connection, hence a module-level channel
 * rather than context: the interceptor exists before any component does.
 */
export function notifyMfaStepUpRequired(detail?: MfaStepUpErrorDetail, context?: { userId?: string }): void {
  for (const listener of [...listeners]) {
    listener(detail || context ? { detail, ...context } : undefined);
  }
}

export function subscribeMfaStepUpRequired(listener: MfaStepUpListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
